/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React from "react"
import { Element, Row, Column, Label, Input, Color } from "trux"

export const ContactEdit = ({
    contact,
    index,
    duplicateEmails,
    removeContact,
    handleOnNameChanged,
    onEmailChanged,
    yesUseMatching,
    noAddingNew,
    validate,
}) => {
    var duplicateUser = null
    if (duplicateEmails) {
        for (var i in duplicateEmails) {
            if (duplicateEmails[i].email === contact.email) {
                duplicateUser = duplicateEmails[i]
                break
            }
        }
    }

    const editable = contact._editable

    var emailError = null
    if (contact.duplicate_email) {
        emailError = "People cannot use the same email address"
    } else {
        emailError = contact.invalid_email
    }

    return (
        <>
            {editable && (
                <Element key={`contact-${index}`}>
                    <Row paddingBottom="2">
                        <Column span="10">
                            <Label
                                marginTop="4"
                                type={Label.Type.Heading4}
                            >{`Family Member ${
                                parseInt(index, 10) + 1
                            }`}</Label>
                        </Column>
                        <Column span="2" alignItems="flex-end">
                            <Element
                                tag="a"
                                id={`remove-${index}`}
                                className="remove-family-member"
                                onClick={(e) => removeContact(e)}
                            >
                                <Label
                                    marginTop="4"
                                    type={Label.Type.Body}
                                    bold
                                    color={Color.Error}
                                    content="Remove"
                                />
                            </Element>
                        </Column>
                    </Row>

                    <Input
                        name={`name-${index}`}
                        label="Full name"
                        value={contact.raw_value}
                        type={Input.Type.Text}
                        onChange={handleOnNameChanged}
                        error={contact.invalid_name}
                        onBlur={validate}
                    />
                    <Input
                        name={`email-${index}`}
                        label="Email"
                        value={contact.email}
                        type={Input.Type.Text}
                        error={emailError}
                        onChange={onEmailChanged}
                        onBlur={validate}
                    />
                    <Row>
                        <Column>
                            {duplicateUser && (
                                <Label
                                    className="duplicate-error"
                                    color={Color.Error}
                                    type={Label.Type.SmallBody}
                                >
                                    Are you trying to add &nbsp;
                                    {duplicateUser.first_name}
                                    &nbsp;
                                    {duplicateUser.last_name}
                                    &nbsp;
                                    <Element
                                        tag="a"
                                        id={`yes-${index}`}
                                        href="#yes"
                                        onClick={yesUseMatching}
                                    >
                                        Yes
                                    </Element>
                                    &nbsp; : &nbsp;
                                    <Element
                                        tag="a"
                                        id={`no-${index}`}
                                        href="#no"
                                        onClick={noAddingNew}
                                    >
                                        No, I&apos;m adding a new person
                                    </Element>
                                </Label>
                            )}
                        </Column>
                    </Row>
                </Element>
            )}
            {editable === false && (
                <ReadOnlyContact
                    contact={contact}
                    index={index}
                    removeContact={removeContact}
                />
            )}
        </>
    )
}

const ReadOnlyContact = ({ contact, index, removeContact }) => {
    var contactInfo = contact
    var contactFullName = contactInfo.first_name + " " + contactInfo.last_name
    return (
        <Element key={`contact-${index}`}>
            <Row>
                <Column span="10" paddingBottom="4">
                    <Label
                        marginTop=""
                        type={Label.Type.Heading4}
                    >{`Family Member ${parseInt(index, 10) + 1}`}</Label>
                </Column>
                <Column span="2" alignItems="flex-end">
                    <Element
                        tag="a"
                        id={`remove-${index}`}
                        className="remove-family-member"
                        onClick={removeContact}
                    >
                        <Label
                            marginTop=""
                            type={Label.Type.Body}
                            bold
                            color={Color.Error}
                            content="Remove"
                        />
                    </Element>
                </Column>
            </Row>
            <Input
                id={`name-${index}`}
                label="Full name"
                value={contactFullName}
                type={Input.Type.Text}
                disabled
            />
            <Input
                id={`email-${index}`}
                label="Email"
                value={contactInfo.masked_email}
                type={Input.Type.Text}
                disabled
            />
        </Element>
    )
}
